@let ticket = result();

<soft-search-result-item
  icon="fa-regular fa-comment"
  [title]="ticket.id + ': ' + ((ticket.name | translate) ?? '')"
  (click)="openTicket(ticket.id)"
/>
